import GoogleAnalyticsTracker from 'utils/shared/google_analytics_tracker.js'

(function($) {

  var $document = $(document);

  // Disable button with a spinner when clicked
  $document.on("click", "[data-behavior~=disable-with-spinner]", function(event) {
    contently.ui.disable_button_with_spinner($(event.currentTarget));
  });

  // Auto-masks forms when submitted
  $document.on("submit", "form[data-behavior~=maskable]", function(event) {
    $(event.currentTarget).addClass("maskable").maskLoading();
  });

  // Auto-unmasks Rails UJS forms when submitted
  $document.on("ajax:complete", "form[data-remote][data-behavior~=maskable]", function(event) {
    $(event.currentTarget).unmaskLoading();
  });

  // Inline save support
  $document.on("change", "form[data-behavior~=inline-save] :input", function(event) {
    $(event.currentTarget.form).submit();
  });

  $document.on("submit", "form[data-behavior~=inline-save]", function(event) {
    $(event.currentTarget)
      .find(".inline-msg").removeClass("saved error").addClass("saving")
  });

  $document.on("ajax:success", "form[data-behavior~=inline-save]", function(event) {
    $(event.currentTarget)
      .find(".inline-msg").removeClass("saving error").addClass("saved")
    setTimeout(function() {
      $(event.currentTarget).find(".row.inline-msg").removeClass("saved");
    }, 2000)
  });

  $document.on("ajax:error", "form[data-behavior~=inline-save]", function(event) {
    $(event.currentTarget)
      .find(".inline-msg").removeClass("saving saved").addClass("error")
  });

  // Support for 'read more' text display. See app/helpers/read_more_helper.rb
  $document.on("click", ".expandable .read-more, .expandable .read-less", function(event) {
    event.preventDefault();
    $(event.currentTarget).closest(".expandable").find(".short-content, .long-content").toggle();
  });

  // Support for a select URL menu
  $document.on("change", "select[data-behavior~=url-menu]", function(event) {
    var url = $.trim($(event.currentTarget).val());
    if (url.length > 0) {
      window.location = url;
    }
  });

  // Support for delete inline confirmations
  var deleteConfirmationWrapperClass = "delete-queue"
  $document.on("click", "[data-behavior~=confirm-delete]", function(event) {
    event.preventDefault();
    $(event.currentTarget).closest(".delete-confirmation-wrapper").addClass(deleteConfirmationWrapperClass);
  });

  $document.on("click", "[data-behavior~=cancel-delete]", function(event) {
    event.preventDefault();
    $(event.currentTarget).closest("." + deleteConfirmationWrapperClass).removeClass(deleteConfirmationWrapperClass);
  });

  $document.on("click", "[data-behavior~=recommendation-toggle]", function(event) {
    var $recLink = $(event.target);
    $recLink.addClass("hidden");
    $recLink.siblings("p").removeClass("hidden");
  });

  // Support for markdown checkboxes
  $document.on("click", "[data-behavior~=markdown] :checkbox", function(event) {
    var $target    = $(event.currentTarget),
        $container = $target.closest("[data-behavior~=markdown]");

    $.post($container.data("url"), {
      index: $target.data("index"),
      checked: $target.is(":checked")
    });
    GoogleAnalyticsTracker.page_event("markdown-checkbox", $target.is(":checked"));
  });

  $document.on("click", "[data-behavior~=banner-close]", function(event) {
    var $notification = $(event.currentTarget).closest(".notification-banner");

    $notification
      .addClass("begone")
      .delay(500)
      .slideUp(400, "linear", function() {
        $notification.remove();
      });
  });

})(jQuery);



// WEBPACK FOOTER //
// ./app/javascript/lib/contently.ui.behaviors.js